import { render, staticRenderFns } from "./Templates_Del.vue?vue&type=template&id=562193c0"
import script from "./Templates_Del.vue?vue&type=script&lang=js"
export * from "./Templates_Del.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports